import { withBrowserTextareaHeight } from '@/src/general/utils/withBrowserTextareaHeight'

import { IntentionsPrayFlowThankStep as IntentionsPrayFlowThankStepNative } from './IntentionsPrayFlowThankStep.shared'

export const IntentionsPrayFlowThankStep = withBrowserTextareaHeight(IntentionsPrayFlowThankStepNative)
